import React, { useState } from "react";
import "./RookGame.css";

const SIZE = 8;

const RookGame = () => {
  const [position, setPosition] = useState({ row: 0, col: 0 }); // a1
  const [turn, setTurn] = useState("A");
  const [winner, setWinner] = useState(null);
  const [message, setMessage] = useState("");
  const [input, setInput] = useState("");

  // Convert board coordinates to chess notation
  const toNotation = (row, col) => {
    const files = "abcdefgh";
    return files[col] + (row + 1);
  };

  // Convert chess notation to board coordinates
  const fromNotation = (notation) => {
    const files = "abcdefgh";
    if (!notation || notation.length < 2) return null;
    const col = files.indexOf(notation[0].toLowerCase());
    const row = parseInt(notation.slice(1)) - 1;
    if (col < 0 || col >= SIZE || isNaN(row) || row < 0 || row >= SIZE)
      return null;
    return { row, col };
  };

  const checkWinner = (row, col, player) => {
    if (row === SIZE - 1 && col === SIZE - 1) {
      setWinner(player);
      return true;
    }
    return false;
  };

  // Player A moves
  const playerMove = (row, col) => {
    if (winner || turn !== "A") return;

    const { row: curRow, col: curCol } = position;

    // must move only up or right
    if (!(row >= curRow && col >= curCol && (row === curRow || col === curCol))) {
      setMessage("❌ Illegal move! You can only move UP or RIGHT.");
      return;
    }

    setMessage("");
    setPosition({ row, col });
    if (checkWinner(row, col, "A")) return;

    setTurn("B");
    setTimeout(() => robotMove(row, col), 600); // robot responds
  };

  // Robot strategy: keep rook on diagonal
  const robotMove = (row, col) => {
    if (winner) return;

    let newRow = row;
    let newCol = col;

    if (row > col) newCol = row; // bring rook to (row,row)
    else if (col > row) newRow = col; // bring rook to (col,col)

    setPosition({ row: newRow, col: newCol });
    if (checkWinner(newRow, newCol, "B")) return;

    setTurn("A");
  };

  const handleInputMove = () => {
    const coords = fromNotation(input);
    if (!coords) {
      setMessage("❌ Invalid notation. Example: e4");
      return;
    }
    playerMove(coords.row, coords.col);
    setInput("");
  };

  const resetGame = () => {
    setPosition({ row: 0, col: 0 });
    setTurn("A");
    setWinner(null);
    setMessage("");
    setInput("");
  };

  return (
    <div className="rook-container">
    
      {winner ? (
        <p className="winner">😒 you lost ... </p>
      ) : (
        <p>Turn: <strong>{turn === "A" ? "Your Turn" : "Robot (B)"}</strong></p>
      )}
      {message && <p className="error">{message}</p>}

      <div className="board">
  {Array.from({ length: SIZE }).map((_, r) => (
    <div key={r} className="row">
      {Array.from({ length: SIZE }).map((_, c) => {
        const boardRow = SIZE - 1 - r; // flip so row 0 = bottom
        const isRook = position.row === boardRow && position.col === c;
        const isTarget = boardRow === SIZE - 1 && c === SIZE - 1;
        const notation = toNotation(boardRow, c);

        const isLight = (boardRow + c) % 2 === 0; // alternate colors

        return (
          <div
            key={c}
            className={`cell ${isLight ? "light" : "dark"} ${
              isTarget ? "target" : ""
            }`}
            onClick={() => turn === "A" && playerMove(boardRow, c)}
          >
            <div className="notation">{notation}</div>
            {isRook ? "♜" : ""}
          </div>
        );
      })}
    </div>
  ))}
</div>

      {!winner && turn === "A" && (
        <div className="notation-move">
          <input
            type="text"
            value={input}
            placeholder="Enter square (e.g. c3)"
            onChange={(e) => setInput(e.target.value)}
          />
          <button style={{background: "#3498db"}} onClick={handleInputMove}>Move</button> 
          
          <button className="restart" onClick={resetGame}>Restart</button>
        </div>
      )}

      
    </div>
  );
};

export default RookGame;
